import { Component, OnInit } from '@angular/core';
import {
  headers,
  mockViewRawData,
} from '../../core/constants/schedules-labor-contants';
import { SchedulesLabor } from '../../core/interface/schedules-labor';
import { SessionStorageService } from '../../core/service/session-storage';
import { UserAccessDetails } from '../../core/interface/user';
import { application } from '../../core/constants/constants';

@Component({
  standalone: false,
  selector: 'app-viewer-home',
  templateUrl: './viewer-home.component.html',
  styleUrl: './viewer-home.component.less',
})
export class ViewerHomeComponent implements OnInit {
  listOfViewRawData: SchedulesLabor[] = mockViewRawData;
  headerData = headers;
  application = application;

  constructor(private readonly session: SessionStorageService) {}

  ngOnInit(): void {
    const userAccess: UserAccessDetails = this.session.getItem('userAccess');
    this.listOfViewRawData[1].reportsDisabled =
      userAccess.ruN_RPTS === 1 ? false : true;
  }
}
